import { Injectable } from '@angular/core';
import { Http, URLSearchParams, RequestOptions, Headers } from '@angular/http';
// import '../../node_modules/rxjs/add/operator/map';
// import '../../node_modules/rxjs/add/operator/timeout';
import { UtilService } from '../services/util.service';
import { CustomerSubmitModel } from '../models/sap/customersubmit.model';
import { CustomerDeleteModel } from '../models/sap/customerdelete.model';
import * as _ from 'lodash';
import { AxiosHttpRequest } from '../infra/axioshttprequest';
import { CustomerMOVRequestModel } from '../models/customer/customerMOVRequest.model';
import { SettingId } from '../enums/settingid.enum';

@Injectable()
export class CustomerService{
    url: string;
    protocol: string;

    constructor(
        private axiosHttpRequest: AxiosHttpRequest
        , private util: UtilService
        , private http: Http
    ) {
        if (location.protocol == 'file:') this.protocol = 'https:';
        else this.protocol = location.protocol;
    }

    retrieveCustomerList(pageNum: number, salesrepCode: string, searchTerm: string, custRoute: string, orderReason:string, setting_id: string){
        const params = {
            pageIndex: pageNum.toString()
            , salesrepCode: salesrepCode
            , searchTerm: searchTerm
            , custRoute: custRoute
            , orderReason: orderReason
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveSalesOrgAndShiptoList(salesrepCode: string, strCustCode: string, strOrderReason: string, setting_id: string){
        const params = {
            salesrepCode: salesrepCode
            , strCustCode: strCustCode
            , strOrderReason: strOrderReason
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerSalesOrgAndShipto';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrievePayerList(salesrepCode: string, strCustCode: string, strSalesOrg: string,strDistchannel:string, strDivision:string, setting_id: string){
        const params = {
            salesrepCode: salesrepCode
            , strCustCode: strCustCode
            , strSalesOrg: strSalesOrg
            , strDistchannel: strDistchannel
            , strDivision: strDivision
            , setting_id: setting_id
        };
     
        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerPayerList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveShiptoList(strCustCode: string, salesrepCode: string, setting_id: string){
        const params = {
            strCustCode: strCustCode
            , salesrepCode: salesrepCode
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerShipto';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveCustomerRouteList(salerepCode: string, setting_id: string){
        const params = {
            salesrepCode: salerepCode
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerRouteList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    /**
     * Google api
     * @param address 
     * @param key 
     * @returns 
     */
    retrieveAddressInfo(address: string, key: string) {
        this.url = this.util.getGMapGeoURL() + '?address=' + address + '&key=' + key; 
        return this.http.get(this.url).map(e => e.json());
    }

    GetAllCustomerList(salesrepCode: string, pageNum:number, searchTerm: string, orderReason:string, setting_id: string){
        const params = {
            salesrepCode: salesrepCode
            , pageIndex: pageNum.toString()
            , searchTerm: searchTerm
            , orderReason: orderReason
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetAllCustomerList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveProvinceList(setting_id: string){
        const params = {
            setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetProvinceList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveOrderReasonList(salerepCode: string, setting_id: string){
        const params = {
            salesrepCode: salerepCode
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetOrderReasonList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    validateSelectedCustomer(selectedCustCode: string, salesInd:string, orderReason: string, salesrepCode: string, setting_id: string){
        const params = {
            selectedCustCode: selectedCustCode
            , orderReason: orderReason
            , salesInd: salesInd
            , salesrepCode: salesrepCode
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/ValidateSelectedCustomer';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveCustomerListFromSAP(
        soldToCode: string
        , soldToName: string
        , shipToCode: string
        , shipToName: string
        , sales_rep_code: string
        , salesarea: string
        , setting_id: string) {

        const params = {
            soldToCode: _.isEmpty(soldToCode) ? '' : soldToCode
            , soldToName: _.isEmpty(soldToName) ? '' : soldToName
            , shipToCode: _.isEmpty(shipToCode) ? '' : shipToCode
            , shipToName: _.isEmpty(shipToName) ? '' : shipToName
            , sales_rep_code: _.isEmpty(sales_rep_code) ? '' : sales_rep_code
            , salesarea: _.isEmpty(salesarea) ? '' : salesarea
            , setting_id: _.isEmpty(setting_id) ? '' : setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerListFromSAP';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveSalesAreaBySalesrepCode(
        salesrepCode: string
        , setting_id: string) {

        const params = {
            salesrepCode: _.isEmpty(salesrepCode) ? '' : salesrepCode
            , setting_id: _.isEmpty(setting_id) ? '' : setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetSalesrepSalesArea';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveCustomerMapping(
        customer_id: string
        , ship_to_code: string
        , ship_to_name: string
        , salesarea: string
        , setting_id: string) {

        const params = {
            customer_id: _.isEmpty(customer_id) ? '' : customer_id
            , ship_to_code: _.isEmpty(ship_to_code) ? '' : ship_to_code
            , ship_to_name: _.isEmpty(ship_to_name) ? '' : ship_to_name
            , salesarea: _.isEmpty(salesarea) ? '' : salesarea
            , setting_id: _.isEmpty(setting_id) ? '' : setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerMappingFromSAP';
        return this.axiosHttpRequest.get(this.url, params);
    }

    saveCustomer(customer: CustomerSubmitModel) {
        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/SaveNewCustomerFromSAP';
        return this.axiosHttpRequest.post(this.url, customer)
    }

    /**
     * Delete all mapping 183 for specific customer
     * @param token 
     * @param customer_id 
     * @param salesrep_code 
     * @param setting_id 
     * @returns 
     */
    deleteCustomer(customer: CustomerDeleteModel) {
        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/DeleteCustomerFromSAP';
        return this.axiosHttpRequest.post(this.url, customer);
    }
    
    updateSurveyStatus(user_id: string){   
        const params = {
            user_id: user_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/UpdateSurveyStatus';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveCustomerMappingListViaAdhoc(salesrepCode: string, soldToCode: string, setting_id: string){
        const params = {
            salesrepCode: salesrepCode
            , soldToCode: soldToCode
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetAdhocCustomerMapping';
        return this.axiosHttpRequest.get(this.url, params);
    }

    /**
     * Delete mapping 183 for specific customer (ship to)
     * @param token 
     * @param customer_id 
     * @param salesrep_code 
     * @param setting_id 
     * @returns 
     */
    deleteCustomerShipTo(customer: CustomerDeleteModel) {
        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/DeleteCustomerShipToFromSAP';
        return this.axiosHttpRequest.post(this.url, customer);
    }

    /**
     * Delete mapping 183 for specific customer (payer)
     * @param token 
     * @param customer_id 
     * @param salesrep_code 
     * @param setting_id 
     * @returns 
     */
    deleteCustomerPayer(customer: CustomerDeleteModel) {
        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/DeleteCustomerPayerFromSAP';
        return this.axiosHttpRequest.post(this.url, customer);
    }

    /**
     * Get the surcharge info
     * @param salesOrg 
     * @param setting_id 
     * @returns 
     */
    getCustomerMOVSurcharge(salesOrg: string, setting_id: string) {
        const params = {
            salesOrg: salesOrg
            , setting_id: setting_id
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerMOVSurcharge';
        return this.axiosHttpRequest.get(this.url, params);
    }

    /**
     * Fetch mov info
     * @param req 
     * @returns 
     */
    getCustomerMOV(req: CustomerMOVRequestModel) {
        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerMOV';
        return this.axiosHttpRequest.post(this.url, req);
    }

    /**
     * Get customer crm
     * @param salesOrg 
     * @param distChannel 
     * @param division 
     * @returns 
     */
    getCustomerCrm(salesOrg: string, distChannel: string, division: string, customerCode, setting_id: string) {
        const params = {
            salesOrg: salesOrg
            , distChannel: distChannel
            , division: division
            , customerCode: customerCode
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerCrm';
        return this.axiosHttpRequest.get(this.url, params);
    }

    checkCustomerContract(soldtoCode: string, shiptoCode: string, salesOrg: string, distChannel: string, division: string, setting_id: string) {
        const params = {
            soldtoCode: soldtoCode
            , shiptoCode: shiptoCode
            , salesOrg: salesOrg
            , distChannel: distChannel
            , division: division
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/CheckCustomerContract';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveCustomerContractList(soldtoCode: string, shiptoCode: string, salesOrg: string, distChannel: string, division: string, setting_id: string) {
        const params = {
            soldtoCode: soldtoCode
            , shiptoCode: shiptoCode
            , salesOrg: salesOrg
            , distChannel: distChannel
            , division: division
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerContractList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    isShowingCustomerCrm(settingId: string): boolean {
        if (settingId !== SettingId.VN) {
            return false;
        }

        return true;
    }
    getCustomerRestrictionPolicy(custCode:string, salesOrg:string, distChannel:string, division:string, setting_id: string){
       const params = {
        salesOrg:salesOrg
        ,distChannel:distChannel
        ,division:division
        ,custCode:custCode
        ,setting_id: setting_id
       }

      this.url = this.protocol + this.util.getWebServiceURL() + 'customer/GetCustomerRestrictionPolicy';
      return this.axiosHttpRequest.get(this.url, params);
    }

    /**
 * Get Customer Operating Hours list
 * @param setting_id
 * @param customer_code
 * @returns
 */
    getCOHList(setting_id: string, customer_code: string) {
        const params = {
            setting_id: setting_id,
            customer_code: customer_code
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetCOHList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    /**
     * Get Holiday list
     * @param setting_id
     * @returns
     */
    getHolidayList(setting_id: string) {
        const params = {
            setting_id: setting_id
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetHolidayList';
        return this.axiosHttpRequest.get(this.url, params);
    }

}


// WEBPACK FOOTER //
// ./src/services/customer.service.ts